import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-banbenduibi",
  "use": "icon-banbenduibi-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-banbenduibi\"><path d=\"M979.057778 128h-403.342222V0H448.284444v128h-409.6c-19.342222 0-38.684444 19.342222-38.684444 38.684444v691.2c0 19.342222 19.342222 38.684444 38.684444 38.684445h409.6V1024h128v-128h403.342223c25.6 0 44.942222-19.342222 44.942222-38.115556V166.684444c-0.568889-19.342222-19.911111-38.684444-45.511111-38.684444zM896 768h-320.284444V256h320.284444v512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol